import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  formGroup: {
    [theme.breakpoints.up('lg')]: {
      marginLeft: theme.spacing(9)
    }
  },
  select: {
    height: 40,
    width: '100%',
    backgroundColor: theme.palette.primary.contrastText,
    '& > div': {
      padding: theme.spacing(1, 1.75),
      paddingTop: theme.spacing(0.5),
      fontWeight: 500
    },
    '& input': {
      height: 3,
      color: theme.palette.primary.main
    },
    '& fieldset': {
      height: 45,
      borderColor: theme.palette.primary.main,
      borderRadius: 5
    },
    '& svg': {
      color: theme.palette.primary.main,
      height: 19
    },
    [theme.breakpoints.up('md')]: {
      width: 430
    }
  },
  labelSelect: {
    color: theme.palette.primary.main,
    fontWeight: 500,
    paddingRight: theme.spacing(),
    backgroundColor: theme.palette.primary.contrastText,
    transform: 'translate(14px, 13px) scale(1)',

    '&.error': {
      color: '#f44336'
    }
  },
  errorMessage: {
    paddingLeft: theme.spacing(2)
  }
}))
